import { render, staticRenderFns } from "./LsInfoRowUpcoming.vue?vue&type=template&id=08205818&"
import script from "./LsInfoRowUpcoming.vue?vue&type=script&lang=js&"
export * from "./LsInfoRowUpcoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports